const searchQueryParamName = "search";
const pageQueryParamName = "page";

export { searchQueryParamName, pageQueryParamName };
